/* eslint-disable no-undef */
// this API instance can be imported in Sagas or wherever service call is happening
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import {
    IMPERSONATED_URL,
    UNAUTHORIZED_API_STATUS_CODE,
} from 'src/constants/appConstants.js';
import { checkImpersonationActive, checkProxyActive, logErrorToConsole } from 'src/utils/util.js';
import { getAuthConfig } from 'src/utils/authConfig';
import {
    UNAUTHORIZED_STATUS_CODE,
    UNAUTHORIZED_TYPE,
    API_CACHE_MAX_AGE,
} from 'src/constants/appConstants';

// Select base URL based on hostname
const getBaseUrl = () => {
    const hostname = window.location.hostname;
    // Check if URL contains 'ous' (e.g., test.ous.mycase.medtronic.com)
    if (hostname.includes('.ous.') && process.env.BASE_URL_OUS) {
        return process.env.BASE_URL_OUS;
    }
    return process.env.BASE_URL;
};

const cache = setupCache({
    maxAge: API_CACHE_MAX_AGE,
});
const axiosInstance = axios.create({
    baseURL: getBaseUrl(),
    adapter: cache.adapter,
    headers: {
        Pragma: 'no-cache',
    },
});
axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;
const getImpersonationHeader = (configParamter) => {
    const impersonationKey = sessionStorage.getItem('impersonationKey');

    if (checkImpersonationActive()) {
        configParamter.headers.ImpersonationKey = impersonationKey;
    }
};
const getProxyHeader = (configParamter) => {
    const impersonationKey = sessionStorage.getItem('ProxyimpersonationKey');

    if (checkProxyActive()) {
        configParamter.headers.ImpersonationKey = impersonationKey;
    }
};
axiosInstance.interceptors.request.use(
    (config) => {
        return new Promise((resolve) => {
            const configParamter = config || {};
            if (!configParamter?.cacheAPI) configParamter.adapter = null;

            const token = localStorage.getItem('authToken');
            const pageName = localStorage.getItem('pageName') || '';
            const networkId = localStorage.getItem('NetworkId') || '';
            const role = localStorage.getItem('Role') || '';
            const date = new Date();
            if (token) {
                configParamter.headers = configParamter.headers || {};
                const isTokenApi = config.url?.includes('/token');

                if (isTokenApi && getAuthConfig().useBasicAuth) {
                    configParamter.headers.Authorization = `Basic ${btoa(process.env.CLIENT_ID_HYBRIS+':'+process.env.CLIENT_SECRET_HYBRIS)}`;
                } else {
                    configParamter.headers.Authorization = `Bearer ${token}`;
                }
                configParamter.headers.PageName = pageName;
                configParamter.headers.NetworkId = networkId;
                configParamter.headers.Role = role;
                configParamter.headers.timeZoneSet = `${date.getTimezoneOffset()}`;

                if (config?.url !== IMPERSONATED_URL) {
                    getImpersonationHeader(configParamter);
                }

                if (checkProxyActive() && config?.url !== IMPERSONATED_URL) {
                    getProxyHeader(configParamter);
                }
                resolve(configParamter);
            } else {
                // Get token from msal and update
                Promise.resolve().then(
                    setTimeout(() => {
                        resolve(configParamter);
                    }, 0)
                );
            }
        });
    },
    (error) => {
        logErrorToConsole(error, 'error in api');
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    function (response) {
        // any interception to reponse
        return response;
    },
    function (error) {
        // --- ErrorBoundary block to attach endpoint and payload ---
        if (error?.config) {
            error.apiEndPoint = error?.config?.url || '';
            error.requestPayload = error?.config?.data || '';
        }
        const token = localStorage.getItem('authToken');
        const responseStatus = error?.response?.status;
        const responseErrorType = error?.response?.data?.errors?.[0]?.type;

        //if unauthorized
        if (
            token &&
            responseStatus === UNAUTHORIZED_STATUS_CODE &&
            responseErrorType === UNAUTHORIZED_TYPE
        ) {
            localStorage.setItem('userAuthenticated', false);
            localStorage.removeItem('authToken');
            location.reload();
        } else if (
            !token &&
            responseStatus &&
            (responseStatus === UNAUTHORIZED_STATUS_CODE ||
                responseStatus === UNAUTHORIZED_API_STATUS_CODE)
        ) {
            localStorage.setItem('userAuthenticated', false);
            localStorage.removeItem('authToken');
            location.reload();
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
